<template>
  <div class="userMain">
    <!-- 搜索框 :pagePermit="pagePermit"-->
    <SearchBar @search="getSearchData" :list="list" :totalCount="totalCount" />

    <!-- 表格 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      max-height="650"
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">{{
          pageSize * (pageIndex - 1) + (scope.$index + 1)
        }}</template>
      </el-table-column>
      <el-table-column class-name="status-col" label="角色名" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="创建时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="更新时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.updateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="备注" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.remark }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div class="action_btn">
            <!-- v-if="pagePermit.includes('_RoleAccounts')" -->
            <el-button size="small" type="text" @click="viewAccount(scope.row)"
              >查看账户</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="handleEditBtn(scope.row)"
              v-if="roleList[path].includes('_Update')"
              >角色修改</el-button
            >
            <!-- v-if="pagePermit.includes('_DistMenu')" -->
            <el-button
              size="small"
              type="text"
              @click="handlePermitBtn(scope.row)"
              v-if="roleList[path].includes('_Edit_permission')"
              >更新权限</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="handleFunctionBtn(scope.row)"
              v-if="roleList[path].includes('_Edit_function')"
              >更新功能</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定删除该角色吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteRole()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看角色分配到的账号 -->
    <RoleTable ref="roleTableRef" :accountData="accountData" />
    <!-- 添加表单 -->
    <AddForm ref="addFormRef" :editData="editData" />
    <!-- :editFormData="editFormData" -->
    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <permit-tree ref="treeRef" :roleId="roleId" :menuObj="menuObj" />
    <function-tree
      ref="functionRef"
      :roleId="roleId"
      :functionObj="functionObj"
    />
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import SearchBar from './components/searchBar';
import AddForm from './components/addForm';
import RoleTable from './components/roleTable';
import FunctionTree from './components/functionTree';
import { mapGetters } from 'vuex';
// import { getToken } from '@/utils/token';
import PermitTree from './components/permitTree'; //查看角色
import {
  getRolePageApi,
  getRoleAccountApi,
  getRoleOperationApi,
} from '@/api/user.js';
import { houseList } from '@/api/houseApi.js';
export default {
  components: {
    Pagination,
    SearchBar,
    AddForm,
    RoleTable,
    PermitTree,
    FunctionTree,
  },

  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
      first: true,
      listLoading: false,
      deleteRow: '',
      editData: false,
      roleId: '',
      dialogVisible: false,
      list: [],
      accountData: [],
      functionObj: [],
      defaultCheckedNodes: [],
      searchData: {},
      menuObj: {},
      totalCount: 0,
      defaultFunctionNodes: [],
      path: '',
    };
  },
  created() {
    // this.pagePermit = this.roleList[this.$route.meta.title];
    // console.log(this.pagePermit);
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.fetchData();
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  watch: {
    paginObj: 'fetchData',
  },
  mounted() {
    this.$store.dispatch('area/setPaginObj', {
      pageSize: 20,
      pageIndex: 1,
    });
  },
  methods: {
    async fetchData() {
      let obj = {};
      obj.pageSize = this.paginObj.pageSize;
      obj.pageIndex = this.paginObj.pageIndex;
      this.listLoading = true;
      const res = await getRolePageApi({ ...obj, ...this.searchData });
      this.listLoading = false;
      if (res.code == 200) {
        this.list = res.data.dataList;
        this.pageSize = res.data.pageSize;
        this.pageIndex = res.data.pageIndex;
        this.totalCount = res.data.totalCount;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      }
    },
    getSearchData(value) {
      this.searchData = value;
      this.first = true;
      this.fetchData();
    },
    // 查看角色对应权限
    async handlePermitBtn(row) {
      // const houseId = JSON.parse(getToken('userInfo')).houseId;
      this.roleId = row.roleId;
      this.defaultCheckedNodes = [];
      try {
        // 获取所有的楼盘
        let houseArr = [];
        const res2 = await houseList();
        if (res2.code === 200) {
          houseArr = res2.data.dataList.map((item) => {
            return {
              houseId: item.houseId,
              name: item.houseName,
              childs: [],
            };
          });
          console.log(houseArr, 'houseArr================');
          this.$nextTick(function () {
            this.$refs.treeRef.houseData = houseArr;
            this.$refs.treeRef.defaultCheckedNodes = this.defaultCheckedNodes;
            this.$refs.treeRef.treeDrawer = true;
          });
        }
        // }
      } catch (error) {
        console.log(error);
      } finally {
        this.$refs.treeRef.treeDrawer = true;
      }
    },
    // 查看角色对应功能
    async handleFunctionBtn(row) {
      this.roleId = row.roleId;
      console.log(row);
      const res = await getRoleOperationApi({ roleId: row.roleId });
      this.$refs.functionRef.list = res.data.operationDtos;
      this.defaultFunctionNodes = res.data.operationDtos.filter(
        (item) => item.select == 1
      );
      this.$refs.functionRef.treeDialog = true;
      this.$nextTick(() => {
        this.$refs.functionRef.changeSelection();
      });
    },
    // 编辑角色
    handleEditBtn(row) {
      this.editData = true;
      this.$refs.addFormRef.dialogAddVisible = true;
      this.$refs.addFormRef.form = row;
    },

    // 查看角色绑定的账号
    async viewAccount(row) {
      const res = await getRoleAccountApi({ roleId: row.roleId });
      if (res.code === 200) {
        this.accountData = res.data;
        this.$refs.roleTableRef.dialogAccountVisible = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.action_btn {
  display: flex;
  flex-direction: column;
  button {
    margin-left: 0px;
  }
}
</style>
